import React, { useEffect, useState } from "react";
import { Container } from "@material-ui/core";
import Footer from "../Common/Footer";
import ProfileSidebar from "../profileSidebar/ProfileSidebar";
import "./UserProfileDetails.css";
import Header from "../Common/Header/Header";
import Axios from "axios";
import { useNavigate } from "react-router-dom";

const UserProfileDetails = () => {
  const [userDetails, setUserDetails] = useState("");
  console.log(userDetails, 13)
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const token = localStorage.getItem("token");
      Axios.get("https://lawacademyadmin.icicle.dev/api/studentWiseData", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((res) => {
        if (res.status === 200) {
          console.log(res.data);
          setUserDetails(res?.data);
        } else {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          navigate("/login");
        }
        // console.log(res.data);
      });
    } catch (error) {
      console.log(error);
    }
  }, []);
  return (
    <>
      <Header />
      <Container className="memory-page">
        <ProfileSidebar />
        <div className="col-lg-8 col-md-8 vstack gap-4">
          <div className="profile-info">
            <div className="card-header border-0 pb-0">
              <div className="text-center">
                <h1 style={{ margin: "20px", fontWeight: "bold" }}>
                  Welcome{" "}
                  <strong style={{ color: "#1B265C", textTransform: "uppercase" }}>
                    {userDetails.name}
                  </strong>
                </h1>
                <hr />
              </div>
              <div className="details-pane">
                <h4>Name : {userDetails.name}</h4>
                <h4>Phone : {userDetails.phone}</h4>
                <h4>ID : {userDetails.serial_number}</h4>
                <h4>Referred By : {userDetails.referred_by}</h4>
              </div>
            </div>
          </div>
        </div>
      </Container>
      <Footer />
    </>
  );
};

export default UserProfileDetails;
